<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="intro-text">
    <p>
      Des contrats d'assurance des biens pour professionnels et entreprises pour protéger <strong>tout ce que votre entreprise possède</strong>,
      notamment vos locaux, tout ce qu'il y a dedans (avez l'informatique, les télécoms, le mobilier, les machines, la marchandise...), vos
      véhicules, les murs de votre local professionnel et vos bâtis en propriétaires, les équipements et matériels techniques utilisés.
    </p>
  </div>

  <div class="insurance-grid">
    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Auto Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Moto Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Flotte Auto</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Flotte Moto</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-fire"></i>
      </div>
      <h3>Multirisque Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-building"></i>
      </div>
      <h3>Multirisque Immeuble - MRI - PNE</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-cog"></i>
      </div>
      <h3>Bris de Machine</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-shield"></i>
      </div>
      <h3>Cybersécurité Informatique</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Loueur de Véhicules</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-shopping-cart"></i>
      </div>
      <h3>Marchandises Transportées</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-truck"></i>
      </div>
      <h3>Transport</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-question-circle"></i>
      </div>
      <h3>Je ne sais pas quel produit il me faut</h3>
    </div>
  </div>

  <div class="important-section">
    <h2>Très Important :</h2>
    <p>
      L'assurance des biens pour professionnels et entreprises correspond aux dommages aux biens des professionnels et entreprises. Vous assurez tout ce qui touche les biens que possède l'entreprise (les personnes ne sont souhaitées assurer correctement l'entreprise alors il vous faudra :
    </p>
    
    <ol>
      <li>Assurer vos locaux professionnels (Incendie, dégâts de eaux, vol, vandalisme de votre commerce, votre bureau, votre usine, votre cabinet, et tout le contenu qu'il s'y trouve) via une <a href="#" class="highlight-link">assurance Multirisque Professionnelle</a> ou une <a href="#" class="highlight-link">assurance Multirisque Immeuble – MRI – PNE</a></li>
      
      <li>Et assurer vos véhicules professionnels (Assurance au tiers, assurance tout risque, RC circulation sur vos véhicules professionnelles à l'unité ou en flotte auto à partir de 3 véhicules auto, moto, scooter) via une <a href="#" class="highlight-link">assurance Auto Professionnelle</a> ou une <a href="#" class="highlight-link">assurance Moto Professionnelle</a> ou une <a href="#" class="highlight-link">assurance Auto Temporaire</a> ou une <a href="#" class="highlight-link">assurance Flotte Auto Professionnelle</a> et enfin une <a href="#" class="highlight-link">assurance Véhicules Atypiques</a></li>
      
      <li>Assurer la perte de la casse de la Marchandise ou du Matériel (Vol, canaliture, casse, perte, équipement, matériel, stock, marchandise, colis) du une <a href="#" class="highlight-link">assurance Marchandises Transportées ou une Assurance Bris de Machine</a></li>
      
      <li>Assurer vos véhicules de transport ou de location, les véhicules de transport des voyageurs comme les TAXI et UBER, les véhicules de transport de marchandises, la messagerie via une <a href="#" class="highlight-link">assurance Loueur de Véhicules</a> ou une <a href="#" class="highlight-link">assurance Transport</a></li>
    </ol>

    <p class="partners-note">
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong>GENERALI, APRIL, AXA SPVIE, SWISSLIFE, ENTORIA, PROGEAS, EURODOMMAGES, HELVETIA, XENASSUR, MUTUELLE DU MOTARD, AMV, ZEPHIR, SOLLY AZAR</strong>.
    </p>
  </div>

</app-page-layout>
